import axiosInstance from "../../../axiosConfig";
import secureLocalStorage from "react-secure-storage";
import { USER, SESSION } from "../../api-routes";
import auth from "../../controllers/auth.controllers";
import mySessionStorage from "../../controllers/sessionStorage.controllers";
import myLocalStorage from "../../controllers/localStorage.controller";

export const checkSessionStatus = async (): Promise<boolean> => {
  const isAuth = await auth.checkTokenSavedAndValidated();
  return isAuth;
};

export interface LoginParams {
  user: string;
  password: string;
}

export interface LoginResponse {
  code: number;
  access_token?: string;
}

export const loginUser = async (
  params: LoginParams
): Promise<LoginResponse> => {
  const patternByEmails = new RegExp(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  );
  const isEmail = patternByEmails.test(params.user);

  const requestParams = {
    session: {
      password: params.password,
      [isEmail ? "email" : "alias"]: params.user,
      service: "capture"
    }
  };

  const response = await axiosInstance.post(SESSION.LOGIN, requestParams);

  if (response.data.code) {
    auth.create(response.data.access_token);
    myLocalStorage.set("session", "active");
  }

  return response.data;
};

export interface UserData {
  user: {
    id: number;
    type: string;
    [key: string]: unknown;
  };
  company: Record<string, unknown>;
  schedules: unknown[];
  [key: string]: unknown;
}

export const fetchUserData = async (): Promise<UserData | null> => {
  try {
    const response = await axiosInstance.get(USER.DATA_USER, {
      headers: {
        Authorization: `Token ${secureLocalStorage.getItem("token")}`
      }
    });
    return response.data.items;
  } catch (error: any) {
    throw error;
  }
};

export const logoutUser = async (): Promise<boolean> => {
  const status = await auth.logout();
  return status;
};

export interface LoginWithAccessCodeParams {
  access_code: string;
  company_id: number;
}

export interface LoginWithAccessCodeResponse {
  code: number;
  access_token?: string;
}

export const loginWithAccessCode = async (
  params: LoginWithAccessCodeParams
): Promise<LoginWithAccessCodeResponse> => {
  const response = await axiosInstance.post(SESSION.LOGIN_ACCESS_CODE, params, {
    headers: {
      Authorization: `Token ${secureLocalStorage.getItem("token")}`
    }
  });

  if (response.data.code) {
    mySessionStorage.set("sessionWithCode", true);
    auth.create(response.data.access_token);
  }

  return response.data;
};
